const Resources = {

    table_headers: [
        {   
            text: 'Number',
            value: 'number',
            type:   "link",
        },
        { 
          text: 'Description',
          align: 'start',
          value: 'description',
          type:   "link",
        },
        { 
            text: 'Minutes',
            value: 'minutes'
        },
        { 
            text: 'Associate',
            value: 'associate'
        },
    ],

    rooms_report_table_headers: [
        {
            text: 'Description',
            align: 'start',
            value: 'custom_description',
            report_value: 'custom_description',
            show: true,
        },
        {
            text: 'Frequency',
            value: 'frequency_name',
            report_value: 'frequency_name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Room Type',
            value: 'room_type_description',
            report_value: 'room_type_description',
            show: true,
        },
        {
            text: 'Task',
            value: 'task',
            report_value: 'task',
            show: true,
        },
        {
            text: 'Last Completed',
            value: 'last_completed',
            report_value: 'last_completed',
            show: true,
        },
        {
            text: 'Next Scheduled',
            value: 'next_scheduled',
            report_value: 'next_scheduled',
            show: true,
        },
        {
            text: 'Minutes',
            value: 'daily_minutes',
            report_value: 'daily_minutes',
            show: true,
        },
    ],

    rooms_report_table_headers_employee: [
        {
            text: 'Description',
            align: 'start',
            value: 'custom_description',
            report_value: 'custom_description',
            show: true,
        },
        {
            text: 'Room Type',
            value: 'room_type_name',
            report_value: 'room_type_name',
            show: true,
        },
        {
            text: 'Task',
            value: 'task_name',
            report_value: 'task_name',
            show: true,
        },
        {
            text: 'Complete',
            value: 'checkbox',
            type: 'checkbox',
            report_value: 'checkbox',
            show: true,
        },
    ],

    rooms_report_totals: [
        {
            daily_minutes:
            {
                show: true,
                text: 'Minutes',
                value: 0,
            },
            
        },
    ],

    employee_table_headers: [
        {   
            text: 'Number',
            value: 'number',
        },
        { 
          text: 'Description',
          align: 'start',
          value: 'description',
          type:   "link",
        },
        { 
            text: 'Minutes',
            value: 'minutes'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Projects',
            href:   '/assignment-projects',
            arrow:  "",
        },
    ],

    room_table_headers: [
        {
            name:       'Order',
            model:      '',
            checkbox:   false,
            id:         'order',
        },
        {
            name:       'Description',
            model:      '',
            checkbox:   false,
            id:         'descripcion',
        },
        {
            name:       'Frequency',
            model:      '',
            checkbox:   false,
            id:         'frequency',
        },
        {
            name:       'Room Type',
            model:      '',
            checkbox:   false,
            id:         'room_type',
        },
        {
            name:       'Task',
            model:      '',
            checkbox:   false,
            id:         'task',
        },
        {
            name:       'Last Completed',
            model:      '',
            checkbox:   false,
            id:         'last_completed',
        },
        {
            name:       'Next Scheduled',
            model:      '',
            checkbox:   false,
            id:         'next_scheduled',
        },
        {
            name:       'Minutes',
            model:      '',
            checkbox:   false,
            id:         'minutes',
        },
    ],

    room_complete_table_headers: [
        {
            name:       'Description',
            model:      '',
            checkbox:   false,
            id:         'description',
        },
        {
            name:       'Frequency',
            model:      '',
            checkbox:   false,
            id:         'frequency',
        },
        {
            name:       'Room Type',
            model:      '',
            checkbox:   false,
            id:         'room_type',
        },
        {
            name:       'Task',
            model:      '',
            checkbox:   false,
            id:         'task_name',
        },
        {
            name:       'Last Completed',
            model:      '',
            checkbox:   false,
            id:         'last_completed',
        },
    ],
    
    scheduled_table_headers: [
        { 
            text:  'Walking#',
            value: 'walking_number',
        },
        { 
            text:  'Description',
            value: 'custom_description',
        },
        { 
            text:  'Frequency',
            value: 'frequency'
        },
        { 
            text:  'Task',
            value: 'task',
        },
    ],

    standard_options:[
        {
            id: 1,
            name: 'Yes',
        },
        {
            id: 0,
            name: 'No',
        },
    ],

    excel_file_headers: {
        'Number': 'number',
        'Description': 'description',
        'Associate': 'associate_id',
        'Show Scheduled Minutes': 'show_minutes'
    },

    excel_fields_required: {
        number: true,
        description: true,
        associate_id: false,
        show_minutes: true,
    },

    empty_format_data: [
        {
            number:       '',
            description:  '',
            associate_id: '',
            show_minutes: 'Yes',
        },
    ],



    helps: [
        {
            label: '¿How to add a Project Assignment?', 
            instruction: `https://scribehow.com/embed/How_to_Add_a_Project_Assignment__RFk0nimtTfu4oeUcxudOHg?as=scrollable`
        },
        {
            label: '¿How to delete Project Assignments?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_Projects_Assignments___4itIy8CSV2nBbvh3b-bQA?as=scrollable`
        },
    ],
}

export default Resources;